// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3gpuW","options":"AnswerScale_options__2LIu9","selected":"AnswerScale_selected__38g_z"};